import * as Yup from 'yup';
import i18n from '../../../../../../translations/strings';
export const ValidationRegistrationCustomerSchema = Yup.object({
  first_name: Yup.string().required(i18n.t('common.requiredField')),
  last_name: Yup.string().required(i18n.t('common.requiredField')),
  email: Yup.string()
    .lowercase()
    .required(i18n.t('common.requiredField'))
    .email(i18n.t('common.validEmail')),
  phone_number: Yup.string()
    .required(i18n.t('common.requiredField'))
    .min(8, i18n.t('registration.validNumber')),

  password: Yup.string()
    .required(i18n.t('common.requiredField'))
    .min(8, i18n.t('registration.passwordShort'))
    .max(32, i18n.t('registration.passwordLong'))
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      i18n.t('registration.passwordError'),
    ),
  vat_number: Yup.string().max(11, i18n.t('registration.vatNumberValidation')),
  tax_code: Yup.string().required(i18n.t('common.requiredField')).max(16, i18n.t('editProfile.taxCodeValidation')).min(16, i18n.t('editProfile.taxCodeValidation')),
  business_name: Yup.string(),
  business_address: Yup.string().required(i18n.t('common.requiredField')),
  business_unique_code: Yup.string().notRequired().test("uniqueCodeTestLength", i18n.t('registration.uniqueCodeValidation'), function (value, context) {
    if (!value) {
      return true
    }
    if (value && value?.length >= 6 && value?.length <= 7) {
      return true
    }
  }),
  business_email: Yup.string().email(i18n.t('common.validEmail')),
  confirm_password: Yup.string()
    .required(i18n.t('common.requiredField'))
    .oneOf([Yup.ref('password')], i18n.t('registration.confirmPasswordError')),
  privacy: Yup.bool()
    .oneOf([true], i18n.t('common.requiredField'))
    .required(i18n.t('common.requiredField')),
});

export const ValidationRegistrationSocialSchema = Yup.object({
  first_name: Yup.string().required(i18n.t('common.requiredField')),
  last_name: Yup.string().required(i18n.t('common.requiredField')),
  email: Yup.string()
    .lowercase()
    .required(i18n.t('common.requiredField'))
    .email(i18n.t('common.validEmail')),
  phone_number: Yup.string()
    .min(8, i18n.t('registration.validNumber'))
    .required(i18n.t('common.requiredField')),
  vat_number: Yup.string().required(i18n.t('common.requiredField')).max(11, i18n.t('registration.vatNumberValidation')).min(11, i18n.t('registration.vatNumberValidation')),
  tax_code: Yup.string().required(i18n.t('common.requiredField')).max(16, i18n.t('editProfile.taxCodeValidation')).min(16, i18n.t('editProfile.taxCodeValidation')),
  business_name: Yup.string().required(i18n.t('common.requiredField')),
  business_address: Yup.string().required(i18n.t('common.requiredField')),
  business_unique_code: Yup.string().notRequired().test("uniqueCodeTest", i18n.t('registration.pecUniqueCodeValidation'), function (value, context) {
    return !( !context.parent.business_email && !value );
  }).test("uniqueCodeTestLength", i18n.t('registration.uniqueCodeValidation'), function (value, context) {
    if (value && value?.length >= 6 && value?.length <= 7) {
      return true
    }
  }),
  business_email: Yup.string().test("pecTest", i18n.t('registration.pecUniqueCodeValidation'), function (value, context) {
    return !( !context.parent.business_unique_code && !value );
  }).email(i18n.t('common.validEmail')),
  privacy: Yup.bool()
    .oneOf([true], i18n.t('common.requiredField'))
    .required(i18n.t('common.requiredField')),
});
